<template>
  <header class="pl-6 pt-6 flex items-center -enter-x">
    <img src="~@/assets/image/img/logo.png" class="logo" />
    <div class="logo-text">极飞科技AI平台</div>
  </header>
</template>
<script lang="ts">
export default {
  name: 'LogoCom',
};
</script>
<style lang="scss" scoped>
.logo {
  width: 66px;

  &-text {
    padding-left: 11px;
    color: #3d3c38;
    font-weight: 700;
    font-size: 18px;
    font-family: 'Roboto';
    font-style: normal;
    line-height: 18px;
  }
}
</style>
